import React from 'react';
import { Flame } from 'lucide-react';

const FlameStrikethrough = ({ className = "w-6 h-6" }) => (
  <div className={`relative inline-flex items-center justify-center ${className}`}>
    <Flame className="w-full h-full" />
    {/* Diagonal strikethrough line - thick red for visibility */}
    <svg 
      className="absolute inset-0 w-full h-full" 
      viewBox="0 0 24 24" 
      fill="none"
      style={{ pointerEvents: 'none' }}
    >
      {/* White outline for contrast */}
      <line 
        x1="2" 
        y1="22" 
        x2="22" 
        y2="2" 
        stroke="white" 
        strokeWidth="5" 
        strokeLinecap="round"
      />
      {/* Bright red line on top */}
      <line 
        x1="2" 
        y1="22" 
        x2="22" 
        y2="2" 
        stroke="#ef4444" 
        strokeWidth="3" 
        strokeLinecap="round"
      />
    </svg>
  </div>
);

export default FlameStrikethrough;
